<ng-container *ngIf="visible">
    <div class="fuse-progress-bar w-100-p" [ngClass]="{'h-100-p': 'visible'}">
        <mat-progress-bar color="accent" [bufferValue]="bufferValue" [mode]="mode" [value]="value"></mat-progress-bar>
        <div class="h-100-p grey-200-bg fuse-progress-layout"></div>
    </div>
</ng-container>
